module.exports = __webpack_public_path__ + "media/images/vp/no.map-419d3cdb48cea0cc1166d9f1aa165147.png";